import React from 'react';

const SorteoComp = ({text, img}) => {
    return (
        <div className='sorteoComp homeCard heroes'>
            <img src={img} alt=''></img>
            <p>{text}</p>
        </div>
    )
}

export default SorteoComp;
